var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUploadThumbnail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.001,
    height: 17.001,
    viewBox: "0 0 17.001 17.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_69",
    "data-name": "Union 69",
    d: "M8770-11715a1,1,0,0,1-1-1v-12.714a1,1,0,0,1,1-1h7.809v3.615h2.288v2.288h3.615v7.809a1,1,0,0,1-1,1Zm4.823-2.595h7.157l-3.58-6.059Zm-4.093,0h3.863l-1.932-3.209Zm1.137-5.405a.64.64,0,0,0,.624.653.642.642,0,0,0,.627-.653.642.642,0,0,0-.627-.653A.64.64,0,0,0,8771.868-11723Zm10.046-2.626v-2.288h-2.288v-1.8h2.288V-11732h1.8v2.291H8786v1.8h-2.288v2.288Z",
    transform: "translate(-8769 11731.999)",
    fill: "#15355c"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadThumbnail);
export default __webpack_public_path__ + "static/media/uploadThumbnail.0d0e37c53b7d91f3c7c5a9b6a072b0e3.svg";
export { ForwardRef as ReactComponent };